<template>
    <div class="vpm-preview">
        <UiTooltipFunction ref="tooltipNode" class-extra-name="vpm-model-tooltip">
            <template #default>
                <!-- 画布 -->
                <div class="vpm-preview-canvas" ref="mainNode"></div>
            </template>
            <template #content>
                <div class="vpm-preview-info-title font-bold">Exon{{ info.number }}</div>
                <div class="vpm-preview-info-layout">
                    <div class="vpm-preview-info-label">Gene</div>
                    <div class="vpm-preview-info-value">{{ info.start }} - {{ info.end }}</div>
                </div>
                <div class="vpm-preview-info-layout" v-show="info.cds">
                    <div class="vpm-preview-info-label">CDS</div>
                    <div class="vpm-preview-info-value">{{ info.cds && info.cds.rStart }} - {{ info.cds && info.cds.rEnd }}</div>
                </div>
                <div class="vpm-preview-info-layout" v-show="info.eggWhite">
                    <div class="vpm-preview-info-label">Protein</div>
                    <div class="vpm-preview-info-value">{{ info.eggWhite && info.eggWhite.start }} - {{ info.eggWhite && info.eggWhite.end }}</div>
                </div>
                <div class="vpm-preview-info-layout" v-show="info.ref">
                    <div class="vpm-preview-info-label">Reference</div>
                    <div class="vpm-preview-info-value" style="word-break: break-all">{{ info.ref }}</div>
                </div>
                <div class="vpm-preview-info-layout" v-show="info.alt">
                    <div class="vpm-preview-info-label">Alteration</div>
                    <div class="vpm-preview-info-value" style="word-break: break-all">{{ info.alt }}</div>
                </div>
            </template>
        </UiTooltipFunction>
    </div>
</template>

<script lang="ts" setup>
import { UiTooltipFunction } from "various-ui";
import { useComposable } from "./src/composable";

const { refs, methods } = useComposable();
const { info, mainNode, tooltipNode } = refs;

defineExpose({ init: methods.init, drawPos: methods.drawPos });
</script>

<style lang="less" scoped>
.vpm-preview {
    :deep(.ui-tooltip-container) {
        width: 100%;
    }
}
</style>

<style lang="less">
.vpm-model-tooltip {
    padding: 16px 24px;
    .vpm-preview-info-title {
        color: var(--uicolor-font-1);
        font-size: 16px;
        line-height: 24px;
        margin-bottom: 8px;
    }

    .vpm-preview-info-layout {
        display: flex;
        margin-bottom: 4px;
        justify-content: space-between;
        .vpm-preview-info-label {
            margin-right: 8px;
        }
    }
}
</style>
